// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"660":"7978a388","692":"5b63e728","885":"d8673ef0"}[chunkId] + ".chunk.js";
};